import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import { HotelResultsFacade } from '@hotels/hotel-results/hotel-results.facade';
import { BaseSearchBarFacade } from '@shared/base-search-bar/base-search-bar-facade';
import { SwipeUpModule } from '@ux/components/swipe-up/swipe-up.module';
import { HotelFilterBarContainer } from '@shared/magic-filter-bar/hotel-filter-bar/hotel-filter-bar.container';
import { SelectedHotelFiltersModule } from '@shared/magic-filter-bar/selected-hotel-filters/selected-hotel-filters.module';
import { HotelFilterBarService } from '@shared/magic-filter-bar/hotel-filter-bar/services/hotel-filter-bar.service';
import { StarsFilterModule } from '@shared/magic-filter-bar/stars-filter/stars-filter.module';
import { FilterBarTagModule } from '@shared/magic-filter-bar/filter-bar-tag/filter-bar-tag.module';
import {
  HotelFilterBarByHotelContainer
} from '@shared/magic-filter-bar/hotel-filter-bar/components/hotel-filter-bar-by-hotel/hotel-filter-bar-by-hotel.container';
import { MobileFilterBarContModule } from '@shared/magic-filter-bar/mobile-filter-bar-cont/mobile-filter-bar-cont.module';
import { HotelFilterBarSlideModule } from '@shared/magic-filter-bar/hotel-filter-bar-slide/hotel-filter-bar-slide.module';
import { PackageFilterBarModule } from '@shared/magic-filter-bar/package-filter-bar/package-filter-bar.module';
import { ByhoursFilterHourModule } from '@shared/magic-filter-bar/byhours-filter-hour/byhours-filter-hour.module';

@NgModule({
  declarations: [
    HotelFilterBarContainer,
    HotelFilterBarByHotelContainer,
  ],
  imports: [
    CommonModule,
    GlobalPipesModule,
    TranslocoModule,
    SwipeUpModule,
    SelectedHotelFiltersModule,
    StarsFilterModule,
    FilterBarTagModule,
    MobileFilterBarContModule,
    HotelFilterBarSlideModule,
    PackageFilterBarModule,
    ByhoursFilterHourModule
  ],
  exports: [
    HotelFilterBarContainer,
  ],
  providers: [
    HotelResultsFacade,
    BaseSearchBarFacade,
    HotelFilterBarService,
  ]
})
export class HotelFilterBarModule { }
